import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { courseService } from "@/services/courseService";

export function useCourses() {
  return useQuery({ queryKey: ["courses"], queryFn: courseService.list });
}

export function useCourse(id) {
  return useQuery({ queryKey: ["course", id], queryFn: () => courseService.get(id), enabled: !!id });
}

export function useCompletion(id) {
  return useQuery({ queryKey: ["completion", id], queryFn: () => courseService.getCompletion(id), enabled: !!id });
}

export function useCompleteCourse(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: courseService.complete,
    ...options,
    onSuccess: (data, id) => {
      qc.invalidateQueries({ queryKey: ["completion", id] });
      qc.invalidateQueries({ queryKey: ["continue-course"] });
      options.onSuccess?.(data, id);
    },
  });
}

export function useGenerateCourse(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: courseService.generate,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["courses"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useDeleteCourse(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: courseService.remove,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["courses"] });
      options.onSuccess?.(...args);
    },
  });
}
